import "./BusinessBenefits.css"

function BusinessBenefits() {
  const benefits = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
      title: "Foreign Company",
      description:
        "Assist foreign companies in establishing a presence in Saudi Arabia with 100% foreign ownership. Guide you through setting up a branch or representative office, ensuring compliance with local regulations and laws.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 21h18" />
          <path d="M5 21V7l8-4v18" />
          <path d="M19 21V11l-6-4" />
        </svg>
      ),
      title: "GCC National LLC",
      description:
        "Help GCC nationals set up Limited Liability Companies (LLCs) in Saudi Arabia. Ensure all legal and regulatory requirements are met for a smooth setup process.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14,2 14,8 20,8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
      ),
      title: "Entrepreneur/Startups License",
      description:
        "Support entrepreneurs and startups in obtaining necessary licenses to operate in Saudi Arabia. Provide guidance on requirements and procedures for securing licenses.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      title: "Regional Headquarters (RHQ)",
      description:
        "Assist companies in establishing Regional Headquarters in Saudi Arabia. Help navigate the regulatory landscape to ensure your RHQ meets all necessary requirements and operates efficiently.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: "GCC National Establishment",
      description:
        "Facilitate setup of establishments for GCC nationals in Saudi Arabia. Ensure compliance with local laws and regulations, providing a streamlined process.",
    },
  ]

  return (
    <div className="business-benefits">
      <div className="container">
        <h2>Business set up</h2>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BusinessBenefits
